import React from "react";

const Copy = (newItems: any[]) => {
  let ls: any = localStorage.getItem("clipboard");
  let items: any[] = [];

  if (ls) {
    ls = JSON.parse(ls);
    items = ls.items ? [...ls.items] : [];
  }

  const uniqueNewItems = newItems.filter((item) => !items.includes(item));

  items = [...items, ...uniqueNewItems];

  localStorage.setItem("clipboard", JSON.stringify({ items }));

  return <div className="copy" id="copy"></div>;
};

export default Copy;
